import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';

export function usePrompt(
  message: string,
  when: boolean,
  bypassRef?: React.MutableRefObject<boolean>
) {
  const blocker = useBlocker(when);

  useEffect(() => {
    if (blocker.state !== 'blocked') {
      return;
    }

    if (bypassRef?.current) {
      bypassRef.current = false;
      blocker.proceed();
      return;
    }

    const confirm = window.confirm(message);

    if (confirm) {
      blocker.proceed();
    } else {
      blocker.reset();
    }
  }, [blocker, message, bypassRef]);
}
